/**
 * 统一组件配置文件
 * deviceType: '话机' | '班牌' | 未设置表示通用
 */
export default [
    {
        name: 'weather',
        icon: 'default', // default 代表默认组件的封面取值
        detail: '天气组件',
        minWidth: 345,
        minHeight: 195,
        width: 345,
        height: 195,
        lockAspectRatio: false, // 组件是否锁定宽高比
    },
    {
        name: 'courses',
        icon: 'default',
        detail: '当前课程组件',
        minWidth: 345,
        minHeight: 195,
        width: 345,
        height: 195,
        lockAspectRatio: false,
        border: true,
    },
    {
        name: 'deptInfo',
        icon: 'default',
        detail: '班级信息组件',
        minWidth: 345,
        minHeight: 195,
        width: 345,
        height: 195,
        lockAspectRatio: false,
    },
    {
        name: 'deptInfoA',
        icon: 'default',
        detail: '班级信息组件A',
        minWidth: 510,
        minHeight: 600,
        width: 510,
        height: 600,
        lockAspectRatio: false,
    },
    {
        name: 'atten',
        icon: 'default',
        detail: '考勤组件',
        minWidth: 345,
        minHeight: 195,
        width: 345,
        height: 195,
        lockAspectRatio: false,
        border: true,
    },
    {
        name: 'week',
        icon: 'default',
        detail: '教学周组件',
        minWidth: 345,
        minHeight: 195,
        width: 345,
        height: 195,
        lockAspectRatio: false,
        border: true,
    },
    {
        name: 'deptVideo',
        icon: null, // 代表在后台展示组件时不使用封面
        detail: '班级视频组件',
        minWidth: 100,
        minHeight: 100,
        width: 300,
        height: 300,
        color: '#fff',
        background: '#000',
        lockAspectRatio: false,
    },
    {
        name: 'notice',
        icon: null,
        detail: '校园公告组件',
        minWidth: 510,
        minHeight: 225,
        width: 1035,
        height: 225,
        lockAspectRatio: false,
        border: true,
    },
    {
        name: 'dayCourse',
        icon: null,
        detail: '今日课程组件',
        minWidth: 705,
        minHeight: 225,
        width: 1035,
        height: 225,
        lockAspectRatio: false,
        border: true,
    },
    {
        name: 'honor',
        icon: null,
        detail: '荣誉组件',
        minWidth: 510,
        minHeight: 225,
        width: 1035,
        height: 225,
        lockAspectRatio: false,
        border: true,
    },
    {
        name: 'style',
        icon: null,
        detail: '班级风采组件',
        minWidth: 75,
        minHeight: 75,
        width: 300,
        height: 300,
        lockAspectRatio: false,
        border: true,
    },
    {
        name: 'classLogo',
        icon: null,
        detail: '班级LOGO组件',
        minWidth: 10,
        minHeight: 10,
        width: 200,
        height: 200,
        lockAspectRatio: false,
        border: true,
    },
    {
        name: 'countdown',
        icon: null,
        detail: '倒计时组件',
        minWidth: 10,
        minHeight: 10,
        width: 550,
        height: 225,
        lockAspectRatio: false,
        border: true,
    },
    {
        name: 'callButtonSquare',
        icon: null,
        detail: '拨打电话组件',
        minWidth: 100,
        minHeight: 60,
        width: 345,
        height: 195,
        lockAspectRatio: false,
        border: true,
    },
    {
        name: 'lostAndFound',
        icon: null,
        detail: '失物招领组件',
        minWidth: 345,
        minHeight: 195,
        width: 345,
        height: 390,
        lockAspectRatio: false,
        border: true,
    },
    {
        name: 'classPhoto',
        icon: null,
        detail: '班级合照组件',
        minWidth: 345,
        minHeight: 195,
        width: 345,
        height: 195,
        lockAspectRatio: false,
        border: true,
    },
    {
        name: 'honorBadges',
        icon: null,
        detail: '吉祥物/五星组件',
        minWidth: 345,
        minHeight: 195,
        width: 345,
        height: 195,
        lockAspectRatio: false,
        border: true,
    },
    {
        name: 'teacherMessage',
        icon: null,
        detail: '教师寄语组件',
        minWidth: 345,
        minHeight: 195,
        width: 345,
        height: 195,
        lockAspectRatio: false,
        border: true,
    },
    {
        name: 'classBase',
        icon: null,
        detail: '班本阵地组件',
        minWidth: 510,
        minHeight: 225,
        width: 1035,
        height: 225,
        lockAspectRatio: false,
        border: true,
    },
    {
        name: 'classConvention',
        icon: null,
        detail: '班本公约组件',
        minWidth: 345,
        minHeight: 195,
        width: 345,
        height: 195,
        lockAspectRatio: false,
        border: true,
    },
    {
        name: 'classDuty',
        icon: null,
        detail: '班级职务/德育扣分明细组件',
        minWidth: 345,
        minHeight: 195,
        width: 345,
        height: 195,
        lockAspectRatio: false,
        border: true,
    },
    {
        name: 'studentHonor',
        icon: null,
        detail: '班本荣誉组件',
        minWidth: 345,
        minHeight: 195,
        width: 345,
        height: 195,
        lockAspectRatio: false,
        border: true,
    },
    {
        name: 'personalSpace',
        icon: null,
        detail: '个人空间组件',
        minWidth: 100,
        minHeight: 60,
        width: 345,
        height: 195,
        lockAspectRatio: false,
        border: true,
    },
    {
        name: 'header',
        icon: null,
        detail: '顶部栏组件',
        minWidth: 510,
        minHeight: 60,
        width: 1920,
        height: 120,
        lockAspectRatio: false,
        border: true,
    },
]


